export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    search: 'Search',
    submit: 'Submit',
    confirm: 'Confirm',
    loading: 'Loading...',
    noData: 'No data',
    success: 'Success',
    error: 'Operation failed',
    view: 'View',
    back: 'Back',
    print: 'Print',
    send: 'Send',
    create: 'Create',
    reset: 'Reset',
    all: 'All',
    unknown: 'Unknown error',
    pleaseLogin: 'Please log in first',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    action: 'Action',
    grade: 'Grade',
    description: 'Description',
    remark: 'Notes',
    date: 'Date',
    time: 'Time',
    class: 'Class',
    student: 'Student',
    teacher: 'Teacher',
    campus: 'Campus',
    role: 'Role',
    notSet: 'Not set',
    notAssigned: 'Unassigned',
    active: 'Active',
    inactive: 'Inactive',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    yes: 'Yes',
    none: 'None',
    fetchFailed: 'Failed to fetch data',
    loadMore: 'Load more',
  },
  nav: {
    dashboard: 'Dashboard',
    students: 'Students',
    classes: 'Classes',
    teachers: 'Teachers',
    campuses: 'Campuses',
    absences: 'Absences',
    makeup: 'Makeup',
    profile: 'Profile',
    auditLog: 'Audit Log',
    dataManagement: 'Data Management',
    logout: 'Logout',
    home: 'Home',
    mine: 'Mine',
  },
  roles: {
    admin: 'Admin',
    teacher: 'Teacher',
    parent: 'Parent',
  },
  login: {
    title: 'Hanwen Chinese',
    subtitle: 'Hanwen Chinese Management System',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    loginBtn: 'Login',
    loginFailed: 'Login failed, please try again',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Please enter your password',
    passwordMin: 'Password must be at least 6 characters',
    helpText: 'For assistance, please contact your class teacher',
    guideLink: 'View Parent User Guide →',
    forgotPassword: 'Forgot password?',
  },
  dashboard: {
    adminTitle: 'Welcome back, {{name}}!',
    adminSubtitle: 'Data overview and quick access',
    teacherTitle: 'Hello, {{name}}!',
    teacherSubtitle: 'You have {{count}} classes today',
    teacherClassCount: 'You are responsible for {{count}} classes',
    systemOverview: 'System Overview',
    welcomeBack: 'Welcome back, {{name}}',
    totalStudents: 'Total Students',
    totalClasses: 'Total Classes',
    quickAccess: 'Quick Access',
    campusOverview: 'Campus Overview',
    teacherOverview: 'Teacher Overview',
    pendingAbsences: 'Pending Absences',
    makeupClasses: 'Makeup Classes',
    recentAbsences: 'Recent Absence Reports',
    upcomingMakeup: 'Upcoming Makeup Classes',
    noCampuses: 'No campuses',
    noTeachers: 'No teachers',
    noAbsences: 'No absence records',
    noMakeup: 'No makeup classes',
    todaySchedule: "Today's Schedule ({{count}})",
    recentSchedule: 'Recent Schedule ({{count}})',
    myClasses: 'My Classes',
    viewAll: 'View All',
    pendingLeave: 'Pending Absences',
    noPendingLeave: 'No pending absence applications',
    checkIn: 'Check In',
    details: 'Details',
    noClassesToday: 'No classes today',
    noClasses: 'No classes',
    students_unit: 'students',
    people_unit: '',
    items_unit: '',
    count_unit: '',
    classes_unit: '',
    approve: 'Approve',
    reject: 'Reject',
    sick: 'Illness',
    personalLeave: 'Personal Leave',
    schoolActivity: 'School Activity',
    session: 'session',
    viewAttendance: 'View Attendance',
    recentAbsencesMakeups: 'Recent Absences/Makeups',
    noRecentRecords: 'No recent records',
    makeup: 'Makeup',
  },
  classes: {
    title: 'Class Management',
    subtitle: '{{count}} classes in total',
    addClass: 'Add Class',
    editClass: 'Edit Class',
    searchPlaceholder: 'Search classes...',
    name: 'Class Name',
    level: 'Level',
    levelXiucai: 'Xiucai Class',
    levelJuren: 'Juren Class',
    levelJinshi: 'Jinshi Class',
    levelZhuangyuan: 'Zhuangyuan Class',
    levelYangXiucai: 'Yang Xiucai Class',
    levelYangJuren: 'Yang Juren Class',
    levelYangJinshi: 'Yang Jinshi Class',
    levelYangZhuangyuan: 'Yang Zhuangyuan Class',
    levelOther: 'Other',
    teacher: 'Teacher',
    campus: 'Campus',
    studentCount: 'Students',
    schedule: 'Schedule',
    description: 'Description',
    instructor: 'Instructor',
    location: 'Campus',
    dayOfWeek: 'Day of Week',
    firstSessionDate: 'First Session Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    totalSessions: 'Total Sessions',
    capacity: 'Capacity',
    noData: 'No classes',
    fullBadge: 'Full',
    deleteConfirm: 'Are you sure you want to delete this class?',
    deleteSuccess: 'Class deleted successfully',
    deleteFailed: 'Failed to delete class',
    saveSuccess: 'Class updated successfully',
    addSuccess: 'Class added successfully',
    saveFailed: 'Failed to save class',
    namePlaceholder: 'Enter class name',
    nameRequired: 'Please enter class name',
    levelRequired: 'Please select a level',
    levelPlaceholder: 'Select level',
    teacherRequired: 'Please select a teacher',
    teacherPlaceholder: 'Select teacher',
    campusRequired: 'Please select a campus',
    campusPlaceholder: 'Select campus',
    dayRequired: 'Please select a day',
    dayPlaceholder: 'Select day',
    firstDateRequired: 'Please select first session date',
    startTimeRequired: 'Please select start time',
    endTimeRequired: 'Please select end time',
    totalSessionsRequired: 'Please enter total sessions',
    capacityRequired: 'Please enter capacity',
    descPlaceholder: 'Enter class description',
    datePlaceholder: 'Select date',
    timePlaceholder: 'Select time',
    capacityPlaceholder: 'Enter capacity',
    details: 'Class Details',
    students: 'Students ({{count}})',
    noStudents: 'No students',
    removeStudentConfirm: 'Remove {{name}} from this class?',
    removeStudentSuccess: '{{name}} removed from class',
    removeStudentFailed: 'Failed to remove student',
    removeFromClass: 'Remove from class',
    fetchFailed: 'Failed to fetch data',
    fetchStudentsFailed: 'Failed to fetch class students',
    viewAttendance: 'View Attendance',
    selectSession: 'Select Session — {{name}}',
    session: 'Session {{index}}',
    sessionPast: 'Completed',
    sessionFuture: 'Upcoming',
    rosterTitle: 'Attendance — {{name}} {{date}}',
    attending: '✅ Attending ({{count}})',
    absent: '❌ Absent ({{count}})',
    makeup: '🔄 Makeup ({{count}})',
    attendanceSummary:
      'Attending: {{attending}} | Absent: {{absent}} | Makeup: {{makeup}}',
    sendToTeacher: 'Send to Teacher',
    sendEmailConfirmTitle: 'Confirm Sending Attendance Email',
    sendEmailConfirmContent:
      'Send attendance email for {{date}} to teacher: {{teacher}}. Confirm?',
    sendEmailConfirmOk: 'Confirm Send',
    sendEmailSuccess: 'Attendance email sent to teacher',
    sendEmailFailed: 'Failed to send email',
    queryFailed: 'Query failed, please try again',
    printTitle: 'Class Attendance Roster',
    noAbsenceRecords: 'No absences',
    studentName: 'Name',
    studentGrade: 'Grade',
    studentOriginClass: 'Original Class',
    colNotes: 'Notes',
    makeupSuffix: '[Makeup]',
    rosterInfo:
      'Class: {{name}} | Date: {{date}} ({{day}}) | Time: {{start}}-{{end}}',
    rosterSummary:
      'Attending: {{attending}} | Absent: {{absent}} | Makeup: {{makeup}}',
    timeLabel: 'Time: ',
    attendingLabel: 'Attending',
    absentLabel: 'Absent',
    makeupLabel: 'Makeup',
    peopleUnit: '',
  },
  students: {
    title: 'Student Management',
    subtitle: '{{count}} students in total',
    addStudent: 'Add Student',
    editStudent: 'Edit Student',
    searchPlaceholder: 'Search students...',
    studentNumber: 'Student ID',
    name: 'Name',
    grade: 'Grade',
    class: 'Class',
    status: 'Status',
    parent: 'Parent',
    action: 'Action',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusGraduated: 'Graduated',
    unassigned: 'Unassigned',
    deleteConfirm: 'Are you sure you want to delete this student?',
    deleteSuccess: 'Student deleted successfully',
    deleteFailed: 'Failed to delete student',
    saveSuccess: 'Student updated successfully',
    addSuccess: 'Student added successfully',
    saveFailed: 'Failed to save student',
    fetchFailed: 'Failed to fetch data',
    noData: 'No students',
    namePlaceholder: 'Enter student name',
    nameRequired: 'Please enter student name',
    numberPlaceholder: 'Enter student ID',
    gradeRequired: 'Please select grade',
    gradePlaceholder: 'Select grade',
    classRequired: 'Please select class',
    classPlaceholder: 'Select class',
    statusRequired: 'Please select status',
    statusPlaceholder: 'Select status',
    parentRequired: 'Please select parent',
    parentPlaceholder: 'Select parent',
  },
  teachers: {
    title: 'Teacher Management',
    subtitle: '{{count}} teachers in total',
    addTeacher: 'Add Teacher',
    editTeacher: 'Edit Teacher',
    searchPlaceholder: 'Search teachers...',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    createdAt: 'Created At',
    action: 'Action',
    details: 'Teacher Details',
    avatar: 'Avatar',
    lastUpdated: 'Last Updated',
    deleteConfirm: 'Are you sure you want to delete this teacher?',
    deleteWarning: 'The teacher will not be able to log in after deletion',
    deleteSuccess: 'Teacher deleted successfully',
    deleteFailed: 'Failed to delete teacher',
    saveSuccess: 'Teacher updated successfully',
    addSuccess: 'Teacher added successfully',
    saveFailed: 'Failed to save teacher',
    fetchFailed: 'Failed to fetch teachers',
    accessDenied: 'Access Denied',
    accessDeniedMsg: 'You do not have permission to access teacher management.',
    namePlaceholder: 'Enter teacher name',
    nameRequired: 'Please enter teacher name',
    nameMin: 'Name must be at least 2 characters',
    emailPlaceholder: 'Enter email address',
    emailRequired: 'Please enter email address',
    emailInvalid: 'Please enter a valid email address',
    phonePlaceholder: 'Enter phone number',
    phoneInvalid: 'Please enter a valid phone number',
    passwordPlaceholder: 'Enter password',
    passwordRequired: 'Please enter password',
    passwordMin: 'Password must be at least 6 characters',
    passwordHint: 'Leave blank to keep existing password',
    roleTeacher: 'Teacher',
    roleAdmin: 'Administrator',
    notSet: 'Not set',
    password: 'Password',
  },
  campuses: {
    title: 'Campus Management',
    subtitle:
      'Manage campus information for Hanwen Academy, including address, contact and phone',
    addCampus: 'Add Campus',
    editCampus: 'Edit Campus',
    searchPlaceholder: 'Search campus name, address or contact...',
    name: 'Campus Name',
    address: 'Address',
    contactPerson: 'Contact Person',
    phone: 'Phone',
    status: 'Status',
    action: 'Action',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    noDesc: 'No description',
    details: 'Campus Details',
    description: 'Description',
    deleteConfirm: 'Are you sure you want to delete this campus?',
    deleteSuccess: 'Campus deleted successfully',
    deleteFailed: 'Failed to delete campus',
    saveSuccess: 'Campus updated successfully',
    addSuccess: 'Campus added successfully',
    saveFailed: 'Failed to save campus',
    fetchFailed: 'Failed to fetch campuses',
    accessDenied: 'Access Denied',
    accessDeniedMsg: 'You do not have permission to access campus management.',
    namePlaceholder: 'e.g., Baulkham Hills Campus',
    addressPlaceholder: 'Enter full campus address',
    phonePlaceholder: 'e.g., (02) 9876 5432',
    contactPlaceholder: 'e.g., Principal Zhang',
    descPlaceholder: 'Enter campus description (optional)',
  },
  absences: {
    title: 'Absence Management',
    submitAbsence: 'Submit Absence',
    searchPlaceholder: 'Search student or class...',
    allStatus: 'All Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    student: 'Student',
    date: 'Date',
    reason: 'Reason',
    submittedAt: 'Submitted At',
    status: 'Status',
    view: 'View',
    review: 'Review',
    deleteConfirm: 'Are you sure you want to delete this absence record?',
    deleteSuccess: 'Absence record deleted',
    deleteFailed: 'Failed to delete absence record',
    saveSuccess: 'Absence record updated',
    addSuccess: 'Absence submitted',
    saveFailed: 'Failed to submit absence record',
    fetchFailed: 'Failed to fetch data',
    noMatch: 'No matching absence records',
    noRecords: 'No absence records',
    noMatchHint: 'Please try different search criteria or clear filters',
    noRecordsHint: 'Click "Submit Absence" to add the first record',
    clearFilter: 'Clear Filters',
    detailTitle: 'Absence Record Details',
    submitTitle: 'Submit Absence Record',
    studentName: 'Student Name',
    studentRequired: 'Please select a student',
    dateRequired: 'Please select absence date',
    reasonRequired: 'Please select a reason',
    reasonSick: 'Illness',
    reasonFamily: 'Family Event',
    reasonSchool: 'School Activity',
    reasonOther: 'Other',
    detailDesc: 'Description',
    detailPlaceholder: 'Please describe the reason in detail...',
    currentStatus: 'Current Status',
    reviewer: 'Reviewer',
    reviewTime: 'Review Time',
    reviewComment: 'Review Comment',
    reviewTitle: 'Review Absence Record',
    reviewDecision: 'Decision',
    reviewDecisionRequired: 'Please select a decision',
    approve: 'Approve',
    reject: 'Reject',
    reviewCommentPlaceholder: 'Enter review comment...',
    class: 'Class',
    none: 'None',
  },
  makeup: {
    title: 'Makeup Management',
    classesTab: 'Makeup Classes',
    bookingsTab: 'My Bookings',
    create: 'Create',
    searchPlaceholder: 'Search makeup classes...',
    scheduled: 'Scheduled',
    completed: 'Completed',
    cancelled: 'Cancelled',
    booked: 'Booked',
    attended: 'Attended',
    absent: 'Absent',
    allStatus: 'All',
    className: 'Class Name',
    classTime: 'Class Time',
    teacherLocation: 'Teacher/Location',
    slots: 'Slots',
    bookedCount: 'Booked',
    capacity: 'Capacity',
    remaining: '{{count}} slots remaining',
    full: 'Full',
    student: 'Student',
    makeupClass: 'Makeup Class',
    bookingTime: 'Booking Time',
    attendance: 'Attendance',
    attended2: 'Attended',
    cancelConfirm: 'Are you sure you want to cancel this booking?',
    cancelSuccess: 'Booking cancelled',
    cancelFailed: 'Failed to cancel booking',
    deleteConfirm: 'Are you sure you want to delete this makeup class?',
    deleteSuccess: 'Makeup class deleted',
    deleteFailed: 'Failed to delete makeup class',
    saveSuccess: 'Makeup class updated',
    addSuccess: 'Makeup class created',
    saveFailed: 'Failed to save makeup class',
    bookSuccess: 'Booked successfully',
    bookFailed: 'Booking failed',
    fetchFailed: 'Failed to fetch data',
    noMatch: 'No matching makeup classes',
    noClasses: 'No makeup classes',
    noMatchHint: 'Please try different search criteria or clear filters',
    noClassesHint: 'Click "Create" to add the first makeup class',
    clearFilter: 'Clear Filters',
    noBookings: 'No bookings',
    noBookingsHint: 'Book available makeup classes on the Makeup Classes page',
    upcomingClasses: 'Upcoming Makeup Classes',
    bookNow: 'Book Now',
    editTitle: 'Edit Makeup Class',
    createTitle: 'Create Makeup Class',
    classNamePlaceholder: 'Enter makeup class name',
    contentDesc: 'Content Description',
    contentPlaceholder: 'Enter makeup content description...',
    makeupDate: 'Makeup Date',
    dateRequired: 'Please select makeup date',
    makeupTime: 'Makeup Time',
    timeRequired: 'Please enter makeup time',
    timePlaceholder: 'e.g., 14:00-16:00',
    instructor: 'Instructor',
    instructorRequired: 'Please enter instructor name',
    location: 'Location',
    locationRequired: 'Please enter location',
    availableSlots: 'Available Slots',
    slotsRequired: 'Please enter available slots',
    bookTitle: 'Book Makeup Class',
    bookDate: 'Makeup Date',
    bookTime: 'Makeup Time',
    bookInstructor: 'Instructor',
    bookLocation: 'Location',
    bookRemaining: 'Remaining Slots',
    bookUnit: '',
    studentName: 'Student Name',
    studentRequired: 'Please select a student',
    noClass: 'No class assigned',
    notesPlaceholder: 'Enter notes...',
    pendingMakeup: 'Scheduled Makeup Classes',
    myBookings: 'My Bookings',
    availableSlotsTitle: 'Available Slots',
  },
  auditLog: {
    title: 'Audit Log',
    total: '{{count}} records',
    backup: 'Backup Now',
    actionType: 'Action Type',
    resourceType: 'Resource Type',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    sendEmail: 'Send Email',
    changePassword: 'Change Password',
    bulkImport: 'Bulk Import',
    resourceClass: 'Class',
    resourceStudent: 'Student',
    resourceTeacher: 'Teacher',
    resourceCampus: 'Campus',
    resourceAbsence: 'Absence',
    resourceMakeup: 'Makeup Booking',
    time: 'Time',
    actor: 'Actor',
    action: 'Action',
    resource: 'Resource Type',
    objectName: 'Object Name',
    detail: 'Details',
    viewDetail: 'View',
    detailTitle: 'Operation Details',
    field: 'Field',
    before: 'Before',
    after: 'After',
    ip: 'IP',
    actorRole: 'Actor Role',
  },
  profile: {
    title: 'Personal Information',
    edit: 'Edit',
    name: 'Name',
    namePlaceholder: 'Enter name',
    email: 'Email',
    emailHint: 'Email is a unique identifier and cannot be modified',
    phone: 'Phone',
    phonePlaceholder: 'Enter phone number',
    phoneInvalid: 'Invalid phone number format',
    saveChanges: 'Save Changes',
    changePassword: 'Change Password',
    passwordHint: 'Changing password regularly helps protect your account',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    passwordRule:
      'Password must be at least 6 characters and contain letters and numbers',
    confirmPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Confirm new password',
    confirmPasswordAgain: 'Enter new password again',
    passwordMismatch: 'Passwords do not match',
    relatedStudents: 'Associated Students',
    logout: 'Logout',
    registeredAt: 'Registered',
    lastLogin: 'Last Login',
    neverLoggedIn: 'Never logged in',
    fetchFailed: 'Failed to fetch user data',
    updateSuccess: 'Profile updated successfully',
    updateFailed: 'Failed to update profile',
    passwordSuccess: 'Password changed successfully',
    passwordFailed: 'Failed to change password',
    loading: 'Loading...',
    loadFailed: 'Unable to load user data',
    userNotLoaded: 'User data not loaded',
    unassignedClass: 'No class assigned',
    statusActive: 'Active',
    reset: 'Reset',
    versionInfo: 'Version',
    frontend: 'Frontend',
    backend: 'Backend',
  },
  parent: {
    homeTitle: 'Hello, {{name}}!',
    homeSubtitle: "Welcome back, check your child's learning schedule",
    pendingMakeup: 'Pending Makeup',
    noPendingMakeup: 'No pending makeup',
    pendingBook: 'Pending',
    book: 'Book',
    originalClass: 'Original: {{date}}',
    validUntil: 'Valid until {{date}} ({{days}} days)',
    upcomingClasses: 'Upcoming Classes',
    recentTwoWeeks: 'Next 4 Weeks',
    allSessions: 'All Sessions',
    noUpcoming: 'No classes in the next two weeks',
    makeupTag: 'Makeup',
    absenceTag: 'Absent',
    makeupReason: 'Makeup for: {{className}}',
    leaveTag: 'Absent',
    allSessionsTitle: 'All Class Sessions',
    classInfo: '{{total}} sessions · {{schedule}} · {{campus}}',
    sessionLabel: '#',
    sessionAbsent: 'Absent',
    sessionToday: 'Today',
    sessionDone: 'Done',
    sessionPending: 'Pending',
    bookModalTitle: 'Book Makeup · {{name}}',
    bookMakeup: 'Book Makeup',
    reselect: 'Reselect',
    confirmBook: 'Confirm Booking',
    originalInfo:
      'Original: {{className}} · {{date}} · Valid until {{deadline}}',
    levelFilter: 'Level Filter',
    loadingSlots: 'Loading...',
    slotsCount: '{{count}} slots available',
    sameLevelOnly: 'Same Level Only',
    showAllLevels: 'Show All Levels',
    noSlots: 'No available slots',
    selectedSlot: 'Selected: {{className}} · {{date}} {{time}} · {{campus}}',
    selectedHint:
      'Click "Confirm Booking" to complete, or click a slot to reselect.',
    submitLeave: 'Request Absence',
    course: 'Course',
    reasonSick: 'Illness',
    reasonFamily: 'Family Affairs',
    reasonSchool: 'School Affairs',
    reasonOther: 'Other',
    reasonRequired: 'Please select a reason',
    detailDesc: 'Description',
    detailPlaceholder: 'Please describe the reason in detail...',
    bookConfirmTitle: 'Confirm Makeup Booking',
    bookConfirmContent:
      'An email will be sent to teacher: {{teacher}} and yourself upon confirmation. Proceed?',
    bookConfirmOk: 'Confirm Booking',
    bookSuccess: 'Booked! Confirmation email sent',
    bookFailed: 'Booking failed',
    leaveConfirmTitle: 'Confirm Absence Application',
    leaveConfirmContent:
      'An email will be sent to teacher: {{teacher}} and yourself upon submission. Proceed?',
    leaveConfirmOk: 'Confirm Submit',
    leaveSuccess: 'Absence submitted',
    leaveFailed: 'Failed to submit absence',
    fetchFailed: 'Failed to fetch data',
    fetchSlotsFailed: 'Failed to fetch available slots',
    layoutTitle: 'Hanwen Academy',
    layoutSubtitle: 'Hanwen Makeup Management',
    layoutParent: 'Parent',
    myChildren: 'My Children',
    childrenCount: '',
    noChildren: 'No child information',
    noName: 'Unnamed',
    noChineseName: 'Chinese name not provided',
    noBirthday: 'Birthday not provided',
    noSchool: 'School not provided',
    profileChangePassword: 'Change Password',
    profileCurrentPassword: 'Current Password',
    profileCurrentRequired: 'Please enter current password',
    profileNewPassword: 'New Password',
    profileNewHint: 'At least 6 characters with letters and numbers',
    profileNewRequired: 'Please enter new password',
    profilePasswordMin: 'Password must be at least 6 characters',
    profilePasswordLetterNumber: 'Password must contain letters and numbers',
    profileConfirmPassword: 'Confirm Password',
    profileConfirmRequired: 'Please confirm your password',
    profilePasswordMismatch: 'Passwords do not match',
    profileConfirmAgain: 'Enter new password again',
    profileSubmit: 'Change Password',
    profileLogout: 'Logout',
    profileChangeSuccess: 'Password changed successfully',
    profileChangeFailed: 'Failed to change password',
    student: 'Student',
    date: 'Date',
  },
  notFound: {
    title: 'Page Not Found',
    message: 'Sorry, the page you visited does not exist',
    backHome: 'Back to Home',
    contactHint:
      'If you think this is an error, please contact your class teacher',
  },
  header: {
    title: 'Hanwen Chinese',
    subtitle: 'Hanwen Chinese Management System',
  },
  weekdays: {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  grades: {
    grade1: 'Grade 1',
    grade2: 'Grade 2',
    grade3: 'Grade 3',
    grade4: 'Grade 4',
    grade5: 'Grade 5',
    grade6: 'Grade 6',
  },
  absenceCard: {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    sick: 'Illness',
    personalLeave: 'Personal Leave',
    schoolActivity: 'School Activity',
    other: 'Other',
    applicationTime: 'Application Time',
    approve: 'Approve',
    reject: 'Reject',
  },
  makeupCard: {
    inProgress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    slots: 'Slots',
    full: 'Full',
    remaining: 'Remaining',
    book: 'Book',
  },
  studentCard: {
    active: 'Active',
    inactive: 'Inactive',
    graduated: 'Graduated',
  },
  guide: {
    pageTitle: 'Parent User Guide',
    pageSubtitle:
      'Hanwen Chinese School · How to Report Absences & Book Makeup Classes',
    sectionLogin: '🔐 Logging In',
    sectionAbsence: '🙋 How to Report an Absence',
    sectionMakeup: '📅 How to Book a Makeup Class',
    step1Title: 'Enter your email and password to log in',
    step1Text:
      'Log in with the email and password provided by your class teacher. You will be redirected to the parent home page automatically.',
    step1Tip:
      'If you have forgotten your password, please contact your class teacher.',
    step2Title: 'Find the class you need to report an absence for',
    step2Text:
      'The home page shows your child\'s upcoming classes for the next two weeks. Each class card has an orange "Absence" button on the right. Tap it, fill in the reason, and submit.',
    step3Title: 'After reporting, a pending makeup appears automatically',
    step3Text1:
      'The class will be marked as "Absent" after the absence is submitted.',
    step3Text2:
      'A pending makeup record will appear at the top of the page showing the original class date and the makeup deadline. Tap "Book" to start booking a makeup class.',
    step4Title: 'Choose a suitable makeup time slot',
    step4Text: 'The dialog lists all available time slots, each showing:',
    step4Item1: 'Class name and level',
    step4Item2: 'Date, time and campus',
    step4Item3: 'Teacher and remaining spots',
    step4Item4:
      '"Recommended" means same level, campus and teacher as the original class',
    step4Confirm:
      'Tap a slot to select it (highlighted). The selection is shown at the bottom — tap "Confirm Booking" to complete. Tap "Reselect" to change your choice.',
    tipsTitle: '💡 Tips',
    tip1: 'Makeup bookings must be made before the deadline — expired credits cannot be used',
    tip2: 'Spots are limited, so book early',
    tip3: 'If you have any questions, please contact your class teacher',
    backToLogin: '← Back to Login',
  },
  forgotPassword: {
    title: 'Forgot Password',
    subtitle: 'Reset your password via email verification code',
    backToLogin: 'Back to Login',
    stepEmail: 'Enter Email',
    stepCode: 'Verify Identity',
    stepPassword: 'Reset Password',
    sendCode: 'Send Code',
    sendFailed: 'Failed to send verification code',
    codeSentTo: 'Verification code sent to:',
    codeRequired: 'Please enter verification code',
    codeLength: 'Code must be 6 digits',
    codePlaceholder: 'Enter 6-digit code',
    verifyCode: 'Verify Code',
    verifyFailed: 'Verification failed',
    resendAfter: 'Resend after {{seconds}}s',
    resendCode: 'Resend Code',
    passwordRequired: 'Please enter new password',
    passwordMin: 'Password must be at least 6 characters',
    newPasswordPlaceholder: 'Enter new password',
    confirmRequired: 'Please confirm new password',
    confirmPasswordPlaceholder: 'Confirm new password',
    passwordMismatch: 'Passwords do not match',
    resetPassword: 'Reset Password',
    resetFailed: 'Failed to reset password',
    successTitle: 'Password Reset Successful',
    successSubtitle: 'Please login with your new password',
  },
  studentEdit: {
    title: 'Edit Student Information',
    name: 'English Name',
    nameRequired: 'Please enter English name',
    namePlaceholder: 'Enter English name',
    chineseName: 'Chinese Name',
    chineseNamePlaceholder: 'Enter Chinese name',
    birthday: 'Birthday',
    birthdayPlaceholder: 'Select birthday',
    school: 'School',
    schoolPlaceholder: 'Enter school name',
    notes: 'Notes',
    notesPlaceholder: 'Enter notes',
    saveSuccess: 'Student information updated successfully',
    saveFailed: 'Failed to update student information',
  },
  dataManagement: {
    title: 'Data Management',
    description: 'Bulk import/export students, parents, and classes data',
    importStudents: 'Import Students',
    importStudentsDesc:
      'Bulk import students and parents via CSV. Class and grade are optional (empty class goes to "Unassigned")',
    downloadTemplate: 'Download Template',
    clickOrDrag: 'Click or drag CSV file here',
    csvFormatHint: 'CSV files only',
    dryRun: 'Dry run (do not save)',
    dryRunComplete: 'Dry run completed',
    importComplete: 'Import completed',
    importFailed: 'Import failed',
    importing: 'Importing...',
    import: 'Start Import',
    selectFileFirst: 'Please select a file first',
    dryRunResult: 'Dry Run Result',
    importResult: 'Import Result',
    importErrors: 'Import Errors',
    importWarnings: 'Import Warnings',
    newParentsPasswordTitle: 'Default Passwords for New Parents',
    newParentsPasswordHint:
      'These parents were created during this import with auto-generated default passwords. Please inform them; they can change the password after first login.',
    defaultPassword: 'Default Password',
    parentsCreated: 'Parents created',
    parentsSkipped: 'Parents skipped',
    studentsCreated: 'Students created',
    studentsSkipped: 'Students skipped',
    exportStudents: 'Export Students',
    exportStudentsDesc: 'Export all student information as CSV file',
    exportClasses: 'Export Classes',
    exportClassesDesc: 'Export all class information as CSV file',
    exportParents: 'Export Parents',
    exportParentsDesc: 'Export all parent information as CSV file',
    userManagement: 'User Management',
    userManagementDesc:
      'Modify user (parent/teacher) information, support role conversion',
    searchUser: 'Search Users',
    searchPlaceholder: 'Enter parent/teacher name, email or phone...',
    searchByStudentPlaceholder: 'Enter student name to search parent...',
    searchBtn: 'Search',
    searchMinLength: 'Search keyword must be at least 2 characters',
    noUserFound: 'No matching users found',
    editUser: 'Edit User',
    saveSuccess: 'User information updated successfully',
    saveFailed: 'Failed to save user information',
    fetchFailed: 'Failed to fetch user information',
    roleChangeWarning:
      'Before changing a teacher to parent, ensure the teacher is not responsible for any classes',
    studentsCountWarning:
      'Before changing a parent to teacher, ensure the parent has no active students',
    classesCount: 'Classes Count',
    studentsCount: 'Students Count',
    roleParent: 'Parent',
    roleTeacher: 'Teacher',
    roleAdmin: 'Admin',
    importFileUpload: 'CSV File Upload',
    importPasteText: 'Paste & Import',
    pasteFormatHint: 'One student+parent per line. Format: class_name,student_name,student_grade,parent_name,parent_email,parent_phone. Class and grade can be left empty (empty class = Unassigned)',
    copyImportFormat: 'Copy Format',
    copyFormatSuccess: 'Import format copied',
    copyFormatFailed: 'Copy failed, please copy manually',
    pasteStudentInfo: 'Please paste student and parent information',
  },
  chatBot: {
    title: 'AI Assistant',
    placeholder: 'Type a message...',
    send: 'Send',
    welcome: 'Hello! I am Hanwen Academy AI Assistant. How can I help you?',
    clearConversation: 'Clear',
    thinking: 'Thinking...',
    error: 'Failed to reply. Please try again later.',
  },
  landing: {
    hero: {
      title: 'Love Learning, Love Chinese',
      cta: 'Enquire Now',
    },
    services: {
      title: 'Our Programs',
      subtitle: 'Comprehensive Chinese language programs for all ages',
      mandarinTitle: 'Mandarin Lessons',
      mandarinSubtitle: 'From Foundations to Fluency',
      mandarinDesc: 'Comprehensive Mandarin lessons for K-12 students, from beginner to advanced, building well-rounded listening, speaking, reading, and writing skills.',
      eventsTitle: 'Community Events',
      eventsSubtitle: 'Cultural Festivals & Community Events',
      eventsDesc: 'Annual gatherings celebrating Chinese culture and traditional festivals',
      learnMore: 'Learn More →',
    },
    advantages: {
      title: 'Why Hanwen',
      intro: 'Hanwen Chinese Community Language School specializes in teaching Mandarin Chinese through small, interactive classes. Our dynamic teaching methods foster students\' engagement and passion, equipping learners to use Chinese confidently in their daily lives.',
      story: 'Founded on March 25, 2019, Hanwen Chinese was the vision of three dedicated young mothers with a deep commitment to Chinese education. Over the past six years, we have expanded from a modest beginning with around 20 students to a thriving school with approximately 250 students across four campuses in Sydney\'s Hills District, as of Term 3, 2025. We take great pride in witnessing each student\'s enthusiasm and progress and are excited to welcome more students to experience the benefits of our expert instruction.',
      vision: 'Our vision is to become a leading institution dedicated to quality Chinese language and culture education, fostering global citizens who are confident, culturally aware, and proud of their Chinese heritage.',
      introImageAlt: 'Students learning in an interactive Mandarin class',
      highlight1: '20 → 250+',
      highlight1Label: 'Students',
      highlight2: '4',
      highlight2Label: 'Campuses',
      highlight3: '2019',
      highlight3Label: 'Established',
      specializationTitle: 'Specialization',
      specializationSubtitle: 'Focused Chinese Education',
      specializationDesc: 'We focus exclusively on Chinese language education, with effective teaching methods tailored to students growing up overseas, helping them achieve real proficiency.',
      teachersTitle: 'Professional Teachers',
      teachersSubtitle: 'Qualified Teaching Team',
      teachersDesc: 'Our educators hold Australian Community Language Teaching certifications and bring years of experience in nurturing students\' language development.',
      smallClassTitle: 'Small Classes',
      smallClassSubtitle: 'Small Group Learning',
      smallClassDesc: 'Standard 10 students per class ensures personalized attention. We tailor instruction to each student\'s level and learning style.',
      communityTitle: 'Community Engagement',
      communitySubtitle: 'Vibrant Community',
      communityDesc: 'Beyond classrooms, we foster a vibrant community through cultural festivals, a Chinese library, and reading challenges.',
    },
    teachers: {
      title: 'Our Teachers',
      subtitle: 'Our educators are highly qualified and passionate about both student welfare and promoting Chinese culture. Each teacher brings unique expertise and dedication to the classroom.',
      yearsSuffix: 'years teaching',
      items: [
        { name: 'Jessica Zhang', exp: '20+', edu: ['Bachelor in English Teaching, Capital Normal University', 'Cert in Teaching Community Languages, University of Sydney', 'Cert IV in Training & Assessment, HBA Learning Centre'], tagline: 'A versatile educator with the ability to teach and connect with students from both Chinese and non-Chinese backgrounds.' },
        { name: 'Lucy Yang', exp: '7+', edu: ['Master of Teaching (Primary), Australian Catholic University', 'Cert in Community Languages Teaching, University of Sydney', 'Master in Computer Science, Tsinghua University'], tagline: 'Proficient in teaching students from both Chinese and non-Chinese backgrounds.' },
        { name: 'Maggie Zhang', exp: '8+', edu: ['Advanced Cert in Teaching Community Languages, University of Sydney', 'Bachelor in Accounting, Xiamen University'], tagline: 'An enthusiastic educator who creates an engaging and positive learning environment for all students.' },
        { name: 'Lisa Yuan', exp: '6+', edu: ['Advanced Cert in Teaching Community Languages, University of Sydney', 'Master in Professional Accounting, UNSW'], tagline: 'A passionate educator who inspires students and fosters a love for Chinese culture and knowledge.' },
        { name: 'Queenie Li', exp: '7+', edu: ['Master in Teaching Chinese to Speakers of Other Languages, Shanxi University', 'MBA, Torrens University Australia'], tagline: 'An excellent educator who inspires and engages students by delivering impactful, adaptive lessons.' },
        { name: 'Eva Xu', exp: '4+', edu: ['Cert in Community Language Teaching, University of Sydney', 'Bachelor in Business Administration, Hunan University', 'Master in Accounting, University of Sydney'], tagline: 'A friendly and approachable teacher who creates a positive, engaging learning environment.' },
        { name: 'Caroline Liang', exp: '3+', edu: ['Bachelor in Environmental Science', 'Cert in Teaching Community Languages, University of Sydney'], tagline: 'Proficient in teaching Chinese-background students with care and dedication.' },
        { name: 'Fiona Zhao', exp: '6+', edu: ['Graduate Diploma in Early Childhood Education, RMIT', 'Bachelor in English, South China University of Technology'], tagline: 'Creative and enthusiastic in teaching students from both Chinese and non-Chinese backgrounds.' },
        { name: 'Grace Xie', exp: '6+', edu: ['Bachelor in Primary School Teaching, Wenzhou University'], tagline: 'Proficient in teaching Chinese-background students with warmth and patience.' },
        { name: 'Jamie Jiang', exp: '14+', edu: ['Master of Education, Beijing Sport University', 'Cert in Teaching Community Languages, University of Sydney'], tagline: 'Creative and enthusiastic in teaching students from both Chinese and non-Chinese backgrounds.' },
        { name: 'Nicole Liu', exp: '4+', edu: ['Diploma of Early Childhood Education and Care', 'Certificate in Teaching Community Languages, University of Sydney'], tagline: 'Proficient in teaching Chinese and non-Chinese background students.' },
      ],
    },
    gallery: {
      title: 'Life at Hanwen',
      subtitle: 'See our community in action',
    },
    promo: {
      alt: 'Mid-Autumn Festival event notice',
      closeAria: 'Close ad',
      dontShowAgain: 'Don\'t show this again',
    },
    programs: {
      mandarin: {
        bannerTitle: 'Mandarin Lessons',
        intro1: 'At Hanwen Chinese, our Mandarin program is designed for K-12 students of all proficiency levels. From absolute beginners to advanced speakers, we provide a structured learning pathway that develops well-rounded language skills — listening, speaking, reading, and writing.',
        intro2: 'Our curriculum is carefully crafted to align with the needs of learners growing up overseas. We emphasize practical communication while building a strong foundation in Chinese characters, grammar, and cultural understanding.',
        intro3: 'Small class sizes (maximum 10 students) allow our experienced teachers to give each student individual attention, ensuring that every child progresses at their own pace while remaining challenged and engaged.',
        intro4: 'We use a blend of textbook-based learning and interactive activities — including storytelling, role-play, songs, and digital tools — to create a dynamic classroom environment that keeps students motivated.',
        intro5: 'Whether your child is starting their Chinese language journey or preparing for advanced proficiency, our program provides the support, resources, and expertise they need to succeed.',
        featuresTitle: 'Teaching Features',
        cta: 'Enquire Now',
      },
      events: {
        bannerTitle: 'Community Events',
        intro1: 'At Hanwen, learning extends beyond the classroom. Our community events bring students, families, and the wider community together to celebrate Chinese culture and traditions throughout the year.',
        intro2: 'From vibrant festival celebrations to educational workshops, these gatherings create meaningful opportunities for hands-on cultural experiences and community bonding.',
        festivalsTitle: 'Annual Festival Celebrations',
        springFestival: 'Chinese New Year',
        springFestivalZh: '春节',
        springFestivalDesc: 'Our biggest celebration featuring lion dances, calligraphy, paper cutting, and traditional treats.',
        dragonBoat: 'Dragon Boat Festival',
        dragonBoatZh: '端午节',
        dragonBoatDesc: 'Students learn about Qu Yuan, make zongzi, and participate in cultural storytelling activities.',
        midAutumn: 'Mid-Autumn Festival',
        midAutumnZh: '中秋节',
        midAutumnDesc: 'Mooncake tasting, lantern making, and poetry readings under the full moon.',
        communityTitle: 'Community Initiatives',
        communityItem1: 'Cultural Festival Celebrations',
        communityItem2: 'Chinese Community Library',
        communityItem3: 'Reading Challenge & Reading BINGO',
        photosTitle: 'Event Highlights',
        cta: 'Enquire Now',
      },
    },
    locations: {
      title: 'Our Locations',
      subtitle: 'Four campuses across the Hills District, Sydney',
      crestwood: 'Crestwood Campus',
      crestwoodVenue: 'Crestwood Community Centre',
      crestwoodAddr: 'Corner of Crestwood Dr and Conway Ct, Baulkham Hills NSW 2153',
      baulkhamHills: 'BHHS Campus',
      baulkhamHillsVenue: 'Baulkham Hills High School',
      baulkhamHillsAddr: '419A Windsor Rd, Baulkham Hills NSW 2153',
      kellyville: 'Kellyville Campus',
      kellyvilleVenue: 'Wrights Road Community Centre',
      kellyvilleAddr: 'Corner Harrington Avenue and Wrights Road, Castle Hill NSW 2155',
      glenwood: 'Glenwood Campus',
      glenwoodVenue: 'Glenwood Community Hub',
      glenwoodAddr: '72 Glenwood Park Dr, Glenwood NSW 2768',
    },
    // about: {
    //   title: 'About Us',
    //   description:
    //     'Hanwen Chinese is dedicated to promoting Chinese language education and culture. We offer quality Mandarin programs for K-12 students across multiple campuses in Sydney, helping students build a strong language foundation and develop a love for Chinese culture.',
    // },
    nav: {
      home: 'Home',
      timetable: 'Timetable',
      about: 'About',
      faq: 'FAQ',
      manage: 'Manage',
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to common questions about Hanwen Chinese',
      categories: {
        about: 'About the School',
        curriculum: 'Curriculum & Learning Goals',
        tuition: 'Tuition & Fees',
        enrolment: 'Enrolment',
        culture: 'Culture & Community',
        teachers: 'Teachers',
        contact: 'Contact',
      },
      about: {
        q1: 'What is Hanwen Chinese Community Language School?',
        a1: 'Hanwen is a community language school based in Baulkham Hills, in Sydney\'s Hills District, specialising in teaching Mandarin Chinese in small classes. Using a dynamic teaching method, Hanwen aims to get students engaged in and passionate about learning Chinese, and to help them use the language in their daily lives.',
        q2: 'Where is the school located?',
        a2: 'Hanwen now runs classes across four campuses:\n\n• Crestwood Campus — Crestwood Community Centre, corner of Crestwood Drive and Conway Court, Baulkham Hills NSW 2153.\nClass times: Monday–Friday 3:30–5:30 PM, Saturday 9:00 AM–12:00 noon.\n\n• BHHS Campus — Baulkham Hills High School, 419A Windsor Road, Baulkham Hills NSW 2153.\nClass times: Saturday 1:30–3:30 PM & 3:30–5:30 PM.\n\n• Kellyville Campus — Wrights Road Community Centre, corner of Harrington Avenue and Wrights Road, Castle Hill NSW 2155.\nClass times: Sunday 4:00–6:00 PM.\n\n• Glenwood Campus — Glenwood Community Hub, 72 Glenwood Park Drive, Glenwood NSW 2768.\nClass times: Sunday 1:30–3:30 PM & 3:30–5:30 PM.',
        q3: 'What age groups does Hanwen teach?',
        a3: 'Hanwen offers classes for children from Kindergarten through Year 12 (K–12). Adults are also catered for through small group and online Mandarin classes, plus private tutoring on enquiry.',
        q4: 'Do you teach students from non-Chinese-speaking families?',
        a4: 'Yes, Hanwen Chinese offers classes for students from non-Chinese-speaking backgrounds. For these students, Hanwen selects teaching materials and methods suited to their needs, aiming to make learning Chinese an easy and enjoyable experience.',
        q5: 'Do you teach any languages other than Mandarin?',
        a5: 'No — Hanwen teaches Mandarin only.',
      },
      curriculum: {
        q1: 'What does Hanwen aim for students to achieve?',
        a1: 'Hanwen\'s view of Chinese proficiency includes:\n\n• Understanding and speaking Chinese fluently\n• Recognising a large number of Chinese characters and reading simple, short articles\n• Understanding the structure and features of Chinese characters\n• Writing a good number of Chinese characters, and typing Chinese using Pinyin on electronic devices\n• Writing simple notes and short articles in Chinese\n• Learning about Chinese culture',
        q2: 'How are students placed into classes?',
        a2: 'Students are allocated to classes based on both their age group and their Chinese language level, ensuring each student studies alongside peers of a similar age and at a level appropriate to them, rather than in a one-size-fits-all class.',
        q3: 'What textbooks and materials does Hanwen use?',
        a3: 'Hanwen\'s core textbook is 人教版小学语文统编教材 (the PEP unified primary school Chinese-language textbook). This is combined with teaching material developed in-house by Hanwen\'s own teachers, tailored to suit students learning Chinese while living overseas.',
        q4: 'How big are the classes?',
        a4: 'Classes are capped at a maximum of 12 students, which the school says helps maintain teaching quality and allows for individualised tutoring.',
      },
      tuition: {
        q1: 'How much does tuition cost?',
        a1: 'If you would like to know more about our tuition fees, please send an email to admin@hanwenchinese.com.',
        q2: 'How is tuition billed?',
        a2: 'Tuition is billed each semester (two terms) at a time: Term 1 & Term 2 fees are charged in January, and Term 3 & Term 4 fees are charged in July.',
      },
      enrolment: {
        q1: 'How do I enrol my child?',
        a1: 'Enrolment is handled through the school — for enrolment enquiries, email admin@hanwenchinese.com.',
        q2: 'When can new students enrol?',
        a2: 'New students are usually enrolled in Term 1 and Term 3.',
        q3: 'When do classes run?',
        a3: 'Hanwen offers Mandarin lessons during the school term. Operating hours are:\n\n• Monday–Friday\n3:30 PM – 5:30 PM\n\n• Saturday\n9:00 AM – 12:00 PM\n1:30 PM – 5:30 PM\n\n• Sunday\n1:30 PM – 3:30 PM\n3:30 PM – 5:30 PM\n4:00 PM – 6:00 PM',
      },
      culture: {
        q1: 'Does Hanwen do more than just language classes?',
        a1: 'Yes — alongside regular classes, Hanwen hosts annual community events that bring students and families together to celebrate Chinese culture and the year\'s learning. These events also give students a chance to showcase their talents.',
        q2: 'What\'s the overall philosophy behind Hanwen\'s programs?',
        a2: 'Hanwen aims to build not just the ability to speak, understand, read, and write Mandarin, but also a curious mindset toward learning and a sense of cultural connectedness.',
      },
      teachers: {
        q1: 'Who teaches the classes?',
        a1: 'Hanwen\'s teachers are experienced and skilled in creating a nurturing, playful atmosphere intended to support the well-rounded (holistic) learning of students.',
      },
      contact: {
        q1: 'How do I get in touch with Hanwen?',
        a1: 'For enrolment enquiries, email admin@hanwenchinese.com. You can also reach out via Hanwen\'s Facebook page (facebook.com/HanwenChinese) or the school\'s website to ask about fees and current term timetables.',
      },
    },
    timetable: {
      title: 'Timetable',
      subtitle: 'Select a term to view class schedules',
      term: 'Term {{n}}',
      day: 'Day {{day}}',
      time: 'Time',
      class: 'Class',
      location: 'Location',
    },
    footer: {
      brandName: 'Hanwen Chinese',
      tagline: 'Nurturing a love for Chinese language and culture in every student',
      contact: 'Contact Us',
      social: 'Follow Us',
      email: 'admin@hanwenchinese.com',
    },
  },
};
